
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRow from '@/components/atoms/TableRow.vue'
import TableHeader from '@/components/atoms/TableHeader.vue'
import TableData from '@/components/atoms/TableData.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { ProofreadUnit } from '@/models/manage/ProofreadList'

/**
 * 校正機能-単元一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRow,
    TableHeader,
    TableData,
    LinkBase,
  },
})
export default class CurriculumUnitList extends Vue {
  /** 単元一覧 */
  @Prop()
  private unitList!: ProofreadUnit[]

  /** 単元選択時の処理 */
  @Prop()
  private eventSelectUnit!: (id: number) => Promise<void>
}
